module.exports = __webpack_public_path__ + "static/media/img_carrousel04.1fa940f0.svg";